window.onload = function () {
  var checkPropertiesInterval = setInterval(function () {
    var properties = document.querySelectorAll(".upcart-item-property");
    var strongProperties = document.querySelectorAll(
      ".upcart-item-property strong"
    );

    properties.forEach(function (property) {
      if (
        property.textContent.includes("customization_id") ||
        property.textContent.includes("_tib_")
      ) {
        property.style.display = "none";
      }
    });

    strongProperties.forEach(function (strongProperty) {
      if (
        strongProperty.textContent.includes("customization_id") ||
        strongProperty.textContent.includes("_tib_")
      ) {
        strongProperty.parentElement.style.display = "none";
      }
    });
  }, 1000);
};

async function checkRemoveButton() {
  if (!window.location.pathname.startsWith("/cart")) return;

  try {
    const response = await fetch("/cart.json");
    const cartData = await response.json();
    const cartItems = cartData.items;

    document.querySelectorAll(".tib_order_item").forEach((row) => {
      const variantId = row.getAttribute("variant_id");
      const customizationId = row.getAttribute("customization_id");

      const matchedItem = cartItems.find(
        (item) =>
          item.variant_id == variantId &&
          item.properties?.customization_id == customizationId
      );
      if (matchedItem) {
        const correctKey = matchedItem.key;
        row.querySelectorAll("line-item-quantity").forEach((lineItem) => {
          const quantityInput = lineItem.querySelector(".quantity-input");
          const removeLink = lineItem.querySelector("a.link");

          if (quantityInput && quantityInput.dataset.lineKey !== correctKey) {
            quantityInput.dataset.lineKey = correctKey;
          }

          if (removeLink) {
            const correctUrl = `/cart/change?id=${correctKey}&quantity=0`;
            if (removeLink.getAttribute("href") !== correctUrl) {
              removeLink.setAttribute("href", correctUrl);
            }
          }
        });
      }
    });
  } catch (error) {
    console.error("error when updating cart:", error);
  }
}

document.addEventListener("DOMContentLoaded", async function () {
//   if (!window.location.pathname.startsWith("/cart")) return;

//   try {
//     const response = await fetch("/cart.json");
//     const cartData = await response.json();
//     const cartItems = cartData.items;

//     document.querySelectorAll(".tib_order_item").forEach((row) => {
//       const variantId = row.getAttribute("variant_id");
//       const customizationId = row.getAttribute("customization_id");

//       const matchedItem = cartItems.find(
//         (item) =>
//           item.variant_id == variantId &&
//           item.properties?.customization_id == customizationId
//       );
      
//       if (matchedItem) {
//         const correctKey = matchedItem.key;
//         row.querySelectorAll("line-item-quantity").forEach((lineItem) => {
//           const quantityInput = lineItem.querySelector(".quantity-input");
//           const removeLink = lineItem.querySelector("a.link");

//           if (quantityInput && quantityInput.dataset.lineKey !== correctKey) {
//             quantityInput.dataset.lineKey = correctKey;
//           }

//           if (removeLink) {
//             const correctUrl = `/cart/change?id=${correctKey}&quantity=0`;
//             if (removeLink.getAttribute("href") !== correctUrl) {
//               removeLink.setAttribute("href", correctUrl);
//             }
//           }
//         });
//       }
//     });
//   } catch (error) {
//     console.error("error when updating cart:", error);
//   }
});

document.addEventListener("DOMContentLoaded", function () {
  checkRemoveButton();

  setTimeout(function(){
    checkRemoveButton();
  }, 2000)
})

document.addEventListener("DOMContentLoaded", function () {
  const imgEls = document.querySelectorAll('img.tee-img-fluid');

  imgEls.forEach((imgEl) => {
    imgEl.style.opacity = 0;
    const wrapper = imgEl.closest(".tee-img-wrapper");
    const spinner = wrapper.querySelector(".tee-clipart-spinner");
    const url = imgEl.getAttribute('data-img-src');
    let timePassed = 0;

    function tryLoadImage() {
      const testImg = new Image();
      
      testImg.onload = function () {
        // imgEl.src = url;
        // imgEl.style.opacity = 1;
        // spinner.style.display = "none";
        // clearInterval(checkInterval);
        const checkDisplay = setInterval(() => {
          if (imgEl.complete && imgEl.naturalWidth > 0) {
            imgEl.style.opacity = 1;
            spinner.style.display = "none";
            clearInterval(checkInterval);
            clearInterval(checkDisplay);
          }
        }, 100);
      };

      testImg.onerror = function () {
        timePassed += 100;
        if (timePassed >= 60000) {
          spinner.style.display = "none";
          spinner.innerHTML = '<div style="color: #333; font-size: 14px; text-align: center; padding-top: 40%;">Please try refreshing the page</div>';
          clearInterval(checkInterval);
        }
      };

      testImg.src = url;
    }

    tryLoadImage();

    const checkInterval = setInterval(tryLoadImage, 100);
  });
  
});


